// extracted by mini-css-extract-plugin
module.exports = {"container":"_242aff3","iconContainer":"_e0f14e7","background":"_86b2550","icon":"_b890a88","tag":"_e52c6a3"};